if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        document.querySelectorAll('body > product-modal[data-cbq-lb]:not([open])').forEach((m) => m.remove());

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
          try { this.cbxEnhance(responseHTML); } catch (e) {}

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // CALOR 21/10: janela com a galeria completa (fotos da cor escolhida) e os detalhes completos do produto
      cbxEnhance(doc) {
        // CALOR 22/10: "Tap to expand" também na janela Choose options — a foto ampliada vai para o body (fica por cima de tudo)
        try {
          document.querySelectorAll('body > product-modal[data-cbq-lb]').forEach((m) => m.remove());
          const pmod = this.modalContent.querySelector('product-modal');
          if (pmod) { pmod.setAttribute('data-cbq-lb', ''); document.body.appendChild(pmod); }
          if (!customElements.get('product-modal') && !document.querySelector('script[data-cbq-pm]')) {
            const qs = document.querySelector('script[src*="quick-add.js"]');
            if (qs) { const s = document.createElement('script'); s.src = qs.src.replace('quick-add.js', 'product-modal.js'); s.defer = true; s.setAttribute('data-cbq-pm', ''); document.head.appendChild(s); }
          }
          if (!window.cbqPmClose) { window.cbqPmClose = 1; document.body.addEventListener('modalClosed', () => { if (document.querySelector('quick-add-modal[open]')) document.body.classList.add('overflow-hidden'); }); }
        } catch (e) {}
        const mc = this.modalContent;
        mc.classList.add('cbq-full');
        const det = doc.querySelector('#calor-details');
        if (det) {
          const sec = det.closest('.shopify-section') || det;
          const wrap = document.createElement('div');
          wrap.className = 'cbq-details';
          wrap.innerHTML = sec.outerHTML.split('id="calor-details"').join('id="calor-details-qa"');
          mc.appendChild(wrap);
          mc.querySelectorAll('a[href="#calor-details"]').forEach((a) => {
            a.addEventListener('click', (e) => {
              e.preventDefault();
              const t = mc.querySelector('#calor-details-qa');
              if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
          });
        }
        document.dispatchEvent(new CustomEvent('shopify:section:load'));
        if (window.cbeShUpd) [50, 300].forEach((t) => setTimeout(window.cbeShUpd, t));
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        /* CALOR 22/10: a janela da foto ampliada fica (vai para o body em cbxEnhance) */

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
